<template>
  <div class="company-container">
    <CompanyManager/> 
  </div>
</template>

<script>

import CompanyManager from "@/views/company/components/company-manager";

export default {
  components: {
    CompanyManager
  }
};
</script>

<style lang="scss">

</style>